import { createFileRoute } from '@tanstack/react-router';

import { bankAccountRequestListScreen, bankAccountRequestListSearch, loadBankAccountRequestListScreen, loadBankAccountRequestMessages } from '@/modules/bank-account-request/route';
import { lazyScreen } from '@/shared/screen';

// Mesmo caminho do legado (`/contas-digitais/solicitacoes`, router.tsx:597-605): o menu passa a apontar para cá pelo manifesto (U15).
export const Route = createFileRoute('/_app/contas-digitais/solicitacoes/')({
  validateSearch: bankAccountRequestListSearch,
  staticData: { screen: bankAccountRequestListScreen },
  loader: () => loadBankAccountRequestMessages(),
  component: lazyScreen(loadBankAccountRequestListScreen, 'BankAccountRequestListScreen'),
});
